// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"83e82f73","767":"e823892d","785":"3b6cb9d1"}[chunkId] + ".chunk.css";
};